import { Col, Form, Row } from "react-bootstrap";
import { useWatch } from "react-hook-form";
import { useUser } from "../../../context/UserContext";
import { PRINT_MINIMUMS_BY_SKU } from "../../../helpers/constants";
import { InlineCheckbox, Input } from "../../fields";
import { TagLists } from "../TagLists";
import { DigitalTemplateSelect } from "./DigitalTemplateSelect";
import { PaperTemplateSelect } from "./PaperTemplateSelect";
import { PrintPaperSelect } from "./PrintPaperSelect";

export const PrintInternalOptions = () => {
  const { user } = useUser();
  const digital_brochure = useWatch({ name: "3006" });
  return (
    <>
      <TagLists LabelComponent={"h2"} className="" type="Print" />
      <Row>
        <Col xs={12}>
          <h2>Brochures</h2>
        </Col>
        {["3001", "3003", "3300", "3213", "3006"].map((sku) => (
          <Col xs={6} key={sku}>
            <InlineCheckbox sku={sku} />
          </Col>
        ))}
        {digital_brochure && (
          <Col xs={6}>
            <DigitalTemplateSelect placeholder="Digital Brochure Size" />
          </Col>
        )}
      </Row>
      {user && (
        <Row>
          <Col>
            <Form.Label>{user?.name}'s Template Brochure Sizes</Form.Label>
            <PaperTemplateSelect type="brochure" />
            Or Select A Size
          </Col>
        </Row>
      )}
      <PrintPaperSelect type="brochure" />
      <Row>
        <Col xs={12}>
          <h2>Rack Cards</h2>
        </Col>
        {["3004", "3005"].map((sku) => (
          <Col xs={6} key={sku}>
            <InlineCheckbox sku={sku} />
          </Col>
        ))}
      </Row>
      {user && (
        <Row>
          <Col>
            <Form.Label>{user?.name}'s Template Rack Card Sizes</Form.Label>
            <PaperTemplateSelect type="rack_card" />
            Or Select A Size
          </Col>
        </Row>
      )}
      <PrintPaperSelect type="rack_card" />
      <Row>
        <Col xs={12}>
          <h2>Other</h2>
        </Col>
      </Row>
      <Row>
        <Col xs={6}>
          <Input
            sku="3401"
            type="number"
            minimum={PRINT_MINIMUMS_BY_SKU[3401]}
          />
        </Col>
      </Row>
      <Row>
        {["3901", "3902"].map((sku) => (
          <Col xs={6} key={sku}>
            <InlineCheckbox sku={sku} />
          </Col>
        ))}
      </Row>
    </>
  );
};
